module.exports = __webpack_public_path__ + "img/elizabeth-cady-stanton.f91853df.png";